module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ignite-workshop-on-financial-modelling.json
// module id = 1358
// module chunks = 269109470040317